import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Checkbox, FormControl, FormControlLabel, Grid } from '@material-ui/core';
import { btMediumGrayColor } from '../../../assets/jss/nextjs-material-kit-pro';
import { stripLeadingNumber, isAdminOrFHT, isStudent, isAlumni, isFHT } from '../../../util/miscUtil';

const styles = makeStyles((theme) => ({
  checklistRow: {
    margin: '10px 0',
    padding: '15px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  checklistColumn: {
    alignItems: 'center',
  },
  checkboxCell: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: 0,
  },
  pointsLabel: {
    fontSize: '1.00rem',
    lineHeight: 1.5,
    fontWeight: 400,
    color: btMediumGrayColor,
  },
  dueLabel: {
    fontSize: '1.00rem',
    lineHeight: 1.5,
    fontWeight: 400,
    color: btMediumGrayColor,
  },
  datePickerRowSpacer: {
    height: 50,
    paddingTop: 8,
    marginBottom: 10,
  },
  datepicker: {
    width: '160px',
    '& .MuiFilledInput-root': {
      background: 'rgb(255, 255, 255)',
    },
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  alignPrintedContent: {
    verticalAlign: 'top',
    fontSize: '1.00rem',
    lineHeight: 1.5,
    fontWeight: 400,

    marginTop: 5,
  },
  underline: {
    margin: '5px 0',
    borderBottom: '1px solid #000',
  },
  checkOutline: {
    border: '1px solid #000',
    borderRadius: 6,
    maxWidth: '35px',
    alignContent: 'center',
    minWidth: '35px',
  },
}));

export default function MilitaryItems(props) {
  const { form, setForm, auth, asvabScore, alumni, startIndex = 1, points, formClasses, items } = props;

  const classes = styles();

  const hasItems = items && items.length > 0;

  const isFieldDisabled = (val) => {
    return !!isAdminOrFHT(auth.roles);
  };

  const isConfirmDisabled = (val) => {
    return !!(isStudent(auth.roles) || isAlumni(auth.roles) || isFHT(auth.roles));
  };

  const renderChecklistItem = (item, number) => {
    return (
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ marginBottom: 10 }}
        className={classes.unprintedContent + ' ' + classes.checkListRow}
        key={item.key}
      >
        <Grid item xs={12} sm={12} md={8} lg={8} className={classes.checklistColumn}>
          <FormControl fullWidth>
            <FormControlLabel
              control={<Checkbox color="default" style={{ alignSelf: 'flex-start' }} />}
              label={`${number}. ${stripLeadingNumber(item.label)}`}
              disabled={isFieldDisabled(form[item.confirmKey])}
              checked={form[item.key]}
              onChange={() => setForm({ ...form, [item.key]: !form[item.key] })}
            />
            {item.extra && item.extra(form, auth, asvabScore, classes)}
          </FormControl>
        </Grid>
        <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '3%' }} className={classes.checklistColumn}>
          <div className={classes.pointsLabel}>{item.points}</div>
        </Grid>
        <Grid item xs={6} sm={6} md={2} lg={2} align="left" className={classes.checklistColumn}>
          <div className={classes.dueLabel}>{item.due}</div>
        </Grid>
        <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '2.5%' }} className={classes.checklistColumn}>
          <Checkbox
            color="default"
            disabled={isConfirmDisabled(form[item.key])}
            checked={form[item.confirmKey]}
            onChange={() => setForm({ ...form, [item.confirmKey]: !form[item.confirmKey] })}
          ></Checkbox>
        </Grid>
      </Grid>
    );
  };
  let number = startIndex;
  return (
    <React.Fragment>
      {hasItems && (
        <Grid container direction="row" className={formClasses.sectionSpacer}>
          <Grid item xs={7} align="left">
            <section align="left" className={formClasses.sectionTitle}>
              Military Option
            </section>
          </Grid>
          <Grid item xs={2}>
            <section align="right" className={formClasses.sectionTitle}>
              <div style={{ fontSize: '1.15rem', fontWeight: 600, paddingRight: '30px' }}>{points}</div>
            </section>
          </Grid>
          <Grid item xs={3}>
            <section align="center" className={formClasses.sectionTitle}>
              <br />
            </section>
          </Grid>
        </Grid>
      )}
      {hasItems &&
        items.map((item) => {
          if (item.type !== 'instruction') {
            const rendered = renderChecklistItem(item, number);
            number++;
            return rendered;
          } else {
            return renderChecklistItem(item, '');
          }
        })}
    </React.Fragment>
  );
}

MilitaryItems.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  auth: PropTypes.object,
  asvabScore: PropTypes.any,
  alumni: PropTypes.bool,
  startIndex: PropTypes.number,
  points: PropTypes.number,
  formClasses: PropTypes.object,
  items: PropTypes.array,
};
